import { request } from "../request"

export interface UrlUnfurlResponse {
  link_meta: {
    url: string
    host?: string
    best_title?: string
    best_image?: string
    description?: string
    external_id?: string
    duration?: string
  }
}

/**
 * Fetch link metadata for a URL (unfurl). Uses authenticated request with JWT/CSRF.
 */
export const fetchUrlUnfurl = async (
  url: string,
): Promise<UrlUnfurlResponse> => {
  return request({
    queryKey: [
      "url_unfurl",
      {
        path: "/api/v1/url_unfurl",
        options: { method: "GET" },
        params: { url },
      },
    ],
  })
}
